import Loader from 'common/modules/loader'
import { PROMPT_TAG, MENU_TAG, HEADER_TAG } from 'common/tags'
import { FRAME_STATES } from '../reducer'

const selectors = {
    // eslint-disable-next-line max-len
    haveAllFrameInitialized: ({ arbiter } = {}) => arbiter?.allFramesReady,
    hasPicoInitialed: ({ arbiter } = {}) => arbiter?.init,
    executePostLoaderActions: ({ arbiter } = {}) => arbiter?.executePostLoaderActions,
    isPicoDisplayed: ({ arbiter } = {}) => {
        const framesToClose = [PROMPT_TAG, MENU_TAG, HEADER_TAG]
        const framesAreShown = (frame) => arbiter?.frames[frame]?.status === FRAME_STATES.DISPLAYED
        return framesToClose.some(framesAreShown)
    },
    decoratorPayload: (state, adBlocked) => {
        const scope = state?.loader?.user ? 'user' : 'guest'

        const tiers = Loader.selectors.tiers(state, scope)
        const currentPlanTierId = Loader.selectors.currentPlanTierId(state)

        const userFirstName = Loader.selectors.userFirstName(state)
        const userEmail = Loader.selectors.userEmail(state)
        const userVerified = Loader.selectors.userVerified(state)
        const userStatus = Loader.selectors.userStatus(state)

        const planOptions = tiers.flatMap((tier) => tier.options)
        const signalsPayload = {
            adBlocked,
            userTier: tiers.find((tier) => tier.id === currentPlanTierId)?.title,
            userEmail,
            userFirstName,
            userStatus,
            userVerified,
        }

        return {
            planOptions,
            signalsPayload,
        }
    },
}

export default selectors
